import { createSlice } from '@reduxjs/toolkit';

import { College } from '@backrs_ui/common-ui';

import { RootState } from '../store';

type CollegeState = Readonly<{
  college?: College;
  loading?: boolean;
  error?: string;
}>;

const initialState: CollegeState = {
  college: undefined,
  loading: false,
  error: undefined,
};

export const collegeSlice = createSlice({
  name: 'collegeState',
  initialState,
  reducers: {
    resetCollege: (state) => {
      state.college = undefined;
      state.loading = false;
      state.error = undefined;
    },
  },
});

export const selectCollege = (state: RootState) => state.college.college;

export const { resetCollege } = collegeSlice.actions;
